var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00001 14V20H3.00001V22H5.00072L5.40157 22.4006L5.7919 22L7.74077 20L16.9258 10.574L18.3407 9.1219L20.1051 7.31122L20.1181 7.32418L21.192 6.222L19.778 4.808L16.9472 7.71306C15.5442 6.60898 13.8035 6 12 6C9.87828 6 7.84345 6.84285 6.34316 8.34315C4.84287 9.84344 4.00001 11.8783 4.00001 14ZM15.541 9.15624C14.5196 8.40959 13.2809 8 12 8C10.4087 8 8.88259 8.63214 7.75737 9.75736C6.63215 10.8826 6.00001 12.4087 6.00001 14V18.9475L15.541 9.15624ZM19.3825 10.918C19.7863 11.8852 20 12.9316 20 14V20H21V22H8.58457L10.5333 20H18V14C18 13.4986 17.9373 13.0036 17.8161 12.5257L19.3825 10.918ZM13 2H11V5H13V2ZM4.22201 4.808L2.80801 6.222L4.93001 8.344L6.34301 6.928L4.22201 4.808ZM8.46448 10.4645C7.5268 11.4021 7.00001 12.6739 7.00001 14H9.00001C9.00001 13.2044 9.31608 12.4413 9.87869 11.8787C10.4413 11.3161 11.2044 11 12 11V9C10.6739 9 9.40216 9.52678 8.46448 10.4645Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-notification.c7b69cde11c7d686bdac5ca83c3ac9e6.svg";